import { Loader } from '@components/loader';
import { ApiKeys } from '@pages/apiKeys';
import { ApiKeyType } from '@root/globalTypes';
import { useDisableApiKey } from '@services/staff/merchant/apiKeys/disable';
import { useListApiKeys } from '@services/staff/merchant/apiKeys/list';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { Row } from '@tanstack/react-table';
import { outletNavScroll } from '@utils/apiHelpers';
import { useEffect } from 'react';

function MerchantApiKeys() {
  const navigate = useNavigate();
  const { localId, merchantId } = useParams({
    from: '/u/$localId/_staff/staff/merchants/$merchantId/api-keys',
  });
  const { data, isPending } = useListApiKeys(merchantId);
  const { mutate: disableApiKey, isPending: disabling } = useDisableApiKey(merchantId);

  function handleSelect(row: Row<ApiKeyType>) {
    const id: string = row.original.id;

    navigate({
      to: '/u/$localId/staff/merchants/$merchantId/api-keys/$id',
      params: { id, localId, merchantId },
    }).catch((err) => console.error(err));
  }

  function newRedirect() {
    navigate({
      to: '/u/$localId/staff/merchants/$merchantId/api-keys/new',
      params: { localId, merchantId },
    }).catch((err) => console.error(err));
  }

  useEffect(() => {
    outletNavScroll();
  }, []);

  if (isPending) return <Loader />;

  return (
    <ApiKeys
      data={data}
      onDisable={disableApiKey}
      disabling={disabling}
      newRedirect={newRedirect}
      onRowSelect={handleSelect}
    />
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/merchants/$merchantId/api-keys')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['api_keys_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: MerchantApiKeys,
});
